import { AlertOptions as GeneratedAlertOptions } from '../../../generated-client/models';
import { StringKeys } from '../../resources/strings/StringKeys';

/**
 * Configuration mapping AlertOptions enum values to their display label StringKeys.
 * This provides a single source of truth for alert option labels used throughout the UI.
 */
export const ALERT_OPTIONS_LABELS = [
  {
    value: GeneratedAlertOptions.NUMBER_0,
    labelKey: StringKeys.USER_DEFINED,
  },
  {
    value: GeneratedAlertOptions.NUMBER_1,
    labelKey: StringKeys.DISABLED,
  },
  {
    value: GeneratedAlertOptions.NUMBER_2,
    labelKey: StringKeys.ENABLED,
  },
] as const;

/**
 * Gets the StringKey for displaying an AlertOptions value.
 * Use with t() function for translation.
 *
 * @param value - The AlertOptions enum value from API
 * @returns StringKey for translation (e.g., StringKeys.USER_DEFINED)
 * @throws Error if value is not a valid AlertOptions value (0, 1, or 2)
 *
 * @example
 * const labelKey = getAlertOptionLabel(config.impact_detection);
 * const translatedLabel = t(labelKey);
 */
export const getAlertOptionLabel = (
  value: GeneratedAlertOptions | number,
): string => {
  const numValue = typeof value === 'number' ? value : Number(value);
  const option = ALERT_OPTIONS_LABELS.find((opt) => opt.value === numValue);

  if (!option) {
    console.error(`Invalid AlertOptions value received from API: ${value}`);
    return StringKeys.UNKNOWN;
  }

  return option.labelKey;
};
